import React from "react";

export const TicketIconV2 = ({ width, height, extraClasses = "", viewBox = "0 0 17 17" }) => {
  return (
    <span role="img" className={extraClasses}>
      <svg
        width={width || "17"}
        height={height || "17"}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.2068 6.70238L14.0481 4.55131L13.7745 4.81734C13.6513 4.95009 13.503 5.05707 13.3382 5.13207C13.1734 5.20707 12.9953 5.24861 12.8143 5.25426C12.6333 5.25992 12.453 5.22959 12.2838 5.16502C12.1146 5.10046 11.9599 5.00295 11.8287 4.87815C11.7032 4.74678 11.6049 4.59185 11.5396 4.4223C11.4743 4.25276 11.4432 4.07196 11.4482 3.89034C11.4531 3.70872 11.494 3.52988 11.5684 3.36414C11.6429 3.1984 11.7494 3.04905 11.8819 2.9247L12.1555 2.65867L9.99684 0.5L4.889 5.60784L0.199219 10.2976L2.35789 12.4563L2.62392 12.1903C2.85782 11.965 3.15007 11.8097 3.46763 11.7418C3.6696 11.7086 3.87667 11.7259 4.07032 11.7922C4.26398 11.8585 4.43818 11.9718 4.57737 12.1219C4.70022 12.2359 4.79912 12.3733 4.86829 12.526C4.93746 12.6787 4.97551 12.8436 4.98022 13.0112C4.96395 13.4113 4.79855 13.7909 4.51656 14.0753L4.25053 14.3489L6.40159 16.5L10.9622 11.9394L16.2068 6.70238ZM5.29946 14.3033C5.57458 13.9189 5.72814 13.4609 5.74031 12.9884C5.73642 12.7219 5.67928 12.4588 5.57224 12.2147C5.46521 11.9706 5.31043 11.7504 5.11703 11.567C4.89449 11.3264 4.61477 11.1459 4.30383 11.0422C3.9929 10.9386 3.66082 10.9151 3.33841 10.9741C2.99284 11.0387 2.66581 11.1789 2.38069 11.3846L1.27095 10.2976L5.15504 6.42114L9.99684 1.57173L11.099 2.68147C10.7826 3.07865 10.6266 3.58002 10.6617 4.08661C10.6969 4.59319 10.9207 5.06818 11.289 5.41781C11.6405 5.78341 12.1158 6.00472 12.6219 6.03846C13.1279 6.0722 13.6284 5.91594 14.0253 5.60024L15.1275 6.70238L11.2662 10.5713L10.7417 10.0468L10.2097 10.5865L10.7265 11.1033L10.5593 11.2705L10.4301 11.3998L10.2857 11.5518L6.40159 15.4283L5.29946 14.3033Z"
          fill="#212121"
        />
        <path
          d="M6.44787 5.74463L7.5196 6.82396L6.97994 7.34083L5.9082 6.2843L6.44787 5.74463Z"
          fill="#212121"
        />
        <path
          d="M8.56136 7.89551L9.6407 8.96724L9.10103 9.50691L8.0293 8.43518L8.56136 7.89551Z"
          fill="#212121"
        />
      </svg>
    </span>
  );
};
